module.exports = __webpack_public_path__ + "img/batman.ad0958d8.png";